export const jobsData = [
  {
    service: 'TV Mounting (up to 65")',
    avgTime: "1–1.5 hrs",
    estPrice: "$79–$120",
    notes: "Wall mounting & cord concealment",
  },
  {
    service: "Faucet Replacement",
    avgTime: "1–1.5 hrs",
    estPrice: "$79–$120",
    notes: "Customer provides faucet",
  },
  {
    service: "Toilet Install or Swap",
    avgTime: "1.5 hrs",
    estPrice: "~$110",
    notes: "Includes wax ring; haul-away optional",
  },
  {
    service: "Light Fixture Install/Swap",
    avgTime: "0.75–1.25 hrs",
    estPrice: "$69–$100",
    notes: "New or replacement",
  },
  {
    service: "Ceiling Fan Install",
    avgTime: "1.5–2 hrs",
    estPrice: "$110–$140",
    notes: "Wiring & bracing must exist",
  },
  {
    service: "Garbage Disposal Replacement",
    avgTime: "1 hr",
    estPrice: "~$79",
    notes: "Includes leak testing",
  },
  {
    service: "Door Repair / Adjustments",
    avgTime: "1–1.5 hrs",
    estPrice: "$79–$110",
    notes: "Hinges, knobs, minor sanding",
  },
  {
    service: "Window Blinds or Curtain Rods",
    avgTime: "0.75–1.25 hrs",
    estPrice: "$69–$100",
    notes: "Up to 3 windows, leveled & anchored",
  },
  {
    service: "Furniture Assembly (IKEA/Wayfair)",
    avgTime: "1–2 hrs",
    estPrice: "$79–$140+",
    notes: "Varies by item complexity",
  },
  {
    service: "Trampoline / Playset / Shed Builds",
    avgTime: "2–4 hrs+",
    estPrice: "$150–$400+",
    notes: "2–4 person jobs, varies by size",
  },
  {
    service: "BBQ Assembly",
    avgTime: "1.5–2.5 hrs",
    estPrice: "$110–$180",
    notes: "Customer provides grill",
  },
  {
    service: "Smoke Detector Install / Battery",
    avgTime: "0.5–1 hr",
    estPrice: "$69–$79",
    notes: "Install or replace",
  },
  {
    service: "Caulking (Shower/Kitchen)",
    avgTime: "1–1.5 hrs",
    estPrice: "$79–$120",
    notes: "Mold-resistant included",
  },
  {
    service: "Toilet Inner Parts / Rebuild",
    avgTime: "1–1.5 hrs",
    estPrice: "$79–$110",
    notes: "Customer provides repair kit",
  },
];
